import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "../../Services/crud.service";
import { MatDialog } from "@angular/material/dialog";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-list-of-all-companies",
  templateUrl: "./list-of-all-companies.component.html",
  standalone: false,
  styles: [
    `
      ::ng-deep .mat-mdc-menu-panel {
        min-width: 50px !important;
      }
      .tooltip {
        z-index: 3000 !important;
        position: fixed !important;
      }
    `,
  ],
})
export class ListOfAllCompaniesComponent implements OnInit {
  @ViewChild("deactiveCompany") deactiveCompany: ElementRef;
  constructor(
    private crudService: CrudService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}
  listOfCompanies: any = [];
  ngOnInit(): void {
    this.isLoading = true;

    this.getAllCompanies();
  }

  modalRef;
  companyId;
  displayStatus;
  isLoading: boolean = false;
  sortDirection = "asc";
  sortedData;
  getAllCompanies() {
    var payload;
    this.crudService.get(
      payload,
      (response) => {
        this.listOfCompanies = response["result"];
        this.sortedData = [...this.listOfCompanies];

        // console.log("list of all companies", this.listOfCompanies);
      },
      "companyRegistrations/getlistofAllCompanies"
    );
    this.isLoading = false;
  }

  disableCompany(id, status) {
    this.companyId = id;
    if (status == "Enabled") {
      this.displayStatus = "Disable";
    } else if (status == "Disabled") {
      this.displayStatus = "Enable";
    }
    this.modalRef = this.modalService.open(this.deactiveCompany, {
      backdrop: "static",
      centered: true,
    });
  }

  c(actionstring) {
    if (actionstring == "save") {
      var result = this.crudService.update(
        null,
        this.modalRef.close(),
        "companyRegistrations/disable/" + this.companyId
      );
      if (result) {
        this.toastr.clear();
        this.toastr.success("Updated company prefrences");
        this.getAllCompanies();
      }
    } else if (actionstring == "cancel") {
      this.modalRef.close();
      this.getAllCompanies();
    }
  }
  changeSort(column: string): void {
    // console.log("change sort called");
    // Toggle sort direction
    if (this.sortDirection === "asc") {
      this.sortDirection = "desc";
    } else {
      this.sortDirection = "asc";
    }

    // Sort based on the selected column and direction
    this.sortedData.sort((a, b) => {
      if (a[column] < b[column]) {
        return this.sortDirection === "asc" ? -1 : 1;
      }
      if (a[column] > b[column]) {
        return this.sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
  }

  resendInvitation(companyDetail) {
    var payload = companyDetail;
    this.crudService.post(
      payload,
      (response) => {
        console.log("resend invitation comp detail", response);
      },
      "userManagements/userVerify"
    );
  }
}
